import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

import { ManagedUserGroupView } from "../../types";

const IdpGroupMappingTableNameCell = ({
  item: group,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLink
        analyticsPage={AnalyticsPageOrganization.OrganizationIdpGroupMapping}
        analyticsTitle="Group Name Clicked"
        analyticsProps={{
          groupName: group.groupName,
        }}
        href={`/settings/idp-group/${group.id}`}
      >
        {group.groupName}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default IdpGroupMappingTableNameCell;
